/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export class GageBinding {
        min: number;
        max: number;
        title: string;
        value: number;
        sectors: GageSector[];
        state: Wars.Domain.Model.Codes.Enums.ClockStatus;
    }

    export class GageSector {
        color: string;
        lo: number;
        hi: number;
        levelColorsGradient:boolean = false; 
    }

    export interface IIManageTimeTrackerSection extends ng.IScope {
        process: Wars.Domain.Model.Dtos.ProcessDto;
        processConfigurationId: string;
        manageSection: Wars.Domain.Model.ManageSection;
        timeTrackers: Wars.Domain.Model.Workflow.TimeTracker[];
        newTimeTrackerId: string;
        addTimeTracker: any;
        delete: any;
        editSecurityMatrix: any;
        trackerChanged: any;
        gageBindings: GageBinding[];
        colSize: number;
    }

    export class ManageTimeTrackerSection implements IDirective {
        link($scope: IIManageTimeTrackerSection, element: JQuery, attrs: angular.IAttributes, controller: IController) {

        }

        restrict: 'E';
        public templateUrl = './app/views/directives/manageForm/manageTimeTrackersSection.html';
        public controller = ['$scope', 'formService', 'timeTrackerService', 'securityMatrixService', 'configurationCacheService', 'deleteService', ManageTimeTrackersSectionController];
        public controllerAs = 'controller';
        public scope: any = {
            process: "=",
            processConfigurationId: "=",
            manageSection: "="
        };
    }

    export class ManageTimeTrackersSectionController {
        private processWatcher: any;

        constructor(
            private $scope: IIManageTimeTrackerSection,
            private formService: services.FormService,
            private timeTrackerService: services.TimeTrackerService,
            private securityMatrixService: services.SecurityMatrixService,
            private configurationCache: services.ConfigurationCacheService,
            private deleteService: services.DeleteService)
        {
            $scope.addTimeTracker = () => this.addTimeTracker();
            $scope.delete = (t) => this.delete(t);
            $scope.editSecurityMatrix = (t) => this.editSecurityMatrix(t);
            $scope.trackerChanged = (t) => this.trackerChanged(t);

            if (!$scope.process) {
                this.timeTrackerService.getTimeTrackerContainersByProcess(this.$scope.processConfigurationId).then(processLevelTimeTrackerContainers => {
                    $scope.timeTrackers = Enumerable.from(processLevelTimeTrackerContainers).select(i => i.myTimeTracker).toArray();
                });
            } else {
                this.setUpGageBindings();
            }
        }

        private enableProcessWatch() {
            this.processWatcher = this.$scope.$watch("process",
                (newValue, oldValue) => {
                    if (newValue !== undefined && newValue !== null && newValue !== oldValue) {
                        this.setUpGageBindings();
                    }
                });
        }

        private disableProcessWatch() {
            if (this.processWatcher) this.processWatcher();
        }

        private setUpGageBindings() {
            this.disableProcessWatch();

            this.$scope.gageBindings = [];
            this.configurationCache.getVersionedProcessConfiguration(this.$scope.process.processConfigurationId).then(processConfiguration => {
                var timeTrackers = Enumerable.from(processConfiguration.myTimeTrackerContainers).select(i => i.myTimeTracker).orderBy(i => i.sortOrder).toArray();

                var clocks = [];
                for (var j = 0; j < timeTrackers.length; j++) {
                    var clock = Enumerable.from(this.$scope.process.clockValues)
                        .where(i => i.timeTrackerUniqueIdentifier === timeTrackers[j].uniqueIdentifier)
                        .firstOrDefault();
                    if (clock != null) {
                        clocks.push(clock);
                    }
                }

                clocks.forEach(t => {

                    let timeTrackerConfig = Enumerable.from(timeTrackers).single(tConfig => tConfig.uniqueIdentifier === t.timeTrackerUniqueIdentifier);

                    let newGageBinding = new GageBinding();
                    newGageBinding.title = timeTrackerConfig.name;
                    newGageBinding.value = t.timeElapsedLastCalculated;
                    newGageBinding.state = t.clockStatus;

                    newGageBinding.sectors = [];

                    let previousHighValue = null;

                    Enumerable.from(timeTrackerConfig.myTimePeriods).orderByDescending(tp => tp.value).forEach(tp => {
                        let sector = new GageSector();
                        sector.color = tp.hexColor;

                        sector.lo = tp.value;

                        if (previousHighValue) {
                            sector.hi = previousHighValue-1;
                        } else {
                            sector.hi = 1000000;
                        }
                        previousHighValue = tp.value;
                        newGageBinding.sectors.push(sector);
                    });

                    this.$scope.gageBindings.push(newGageBinding);
                });
                if (this.$scope.gageBindings.length == 1) {
                    this.$scope.colSize = 12;
                }
                else if (this.$scope.gageBindings.length % 2 == 0) {
                    this.$scope.colSize = 6;
                }
                else {
                    this.$scope.colSize = 4;
                }

                this.enableProcessWatch();
            });
        }

        private trackerChanged(t) {
            this.$scope.newTimeTrackerId = t;
        }

        private editSecurityMatrix(timeTracker: Wars.Domain.Model.ManageTimeTrackerConfiguration) {
            if (timeTracker.securityMatrix) {
                this.securityMatrixService.openSecurityMatrixModal(timeTracker.securityMatrix, this.$scope.processConfigurationId);
            }
            else {
                timeTracker.securityMatrix = this.securityMatrixService.createSecurityMatrix(false);
                timeTracker.securityMatrix_id = timeTracker.securityMatrix.id;
                this.formService.saveAllChanges(() => {
                    this.securityMatrixService.openSecurityMatrixModal(timeTracker.securityMatrix, this.$scope.processConfigurationId);
                });
            }
        }

        private delete(timeTracker: Wars.Domain.Model.ManageTimeTrackerConfiguration) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ManageTimeTrackerConfiguration",
                timeTracker.id,
                "Time Tracker Section");
        }

        private addTimeTracker() {
            var tracker = this.formService.createManageTimeTrackerConfiguration();
            //console.log(this.$scope);
            tracker.manageSection_id = this.$scope.manageSection.id;
            tracker.timeTracker_id = this.$scope.newTimeTrackerId;
            tracker.securityMatrix = this.securityMatrixService.createSecurityMatrix(false);
            tracker.securityMatrix_id = tracker.securityMatrix.id;
            

            this.$scope.manageSection.manageClockConfigurations.push(tracker);

            this.formService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('ManageTimeTrackerSection', []);